import MailgunEmailPreviews from '../../pages/mailgun/EmailPreviews';
import CreateEmailPreview from '../../pages/mailgun/CreateEmailPreview.vue';
import ShowEmailPreview from '../../pages/mailgun/ShowEmailPreview.vue';
import AdminMailgunMessages from '../../pages/emails/admin/AdminMailgunMessages.vue';
import AdminShowMessage from '../../pages/emails/admin/AdminShowMessage.vue';

export default [
  { // MLD-4550
    path: '/v2/admin/email-previews',
    name: 'admin.mailgun.email_previews',
    component: MailgunEmailPreviews,
  },
  { // MLD-4550
    path: '/v2/admin/email-previews/create',
    name: 'admin.mailgun.email_preview.create',
    component: CreateEmailPreview,
  },
  { // MLD-4550
    path: '/v2/admin/email-previews/:previewID(\\d+)',
    name: 'admin.mailgun.email_preview.show',
    component: ShowEmailPreview,
  },
  { // MLD-5635
    path: '/v2/admin/mailgun/messages',
    name: 'admin.mailgun_messages.index',
    component: AdminMailgunMessages,
    meta: {
      permission: 'can_edit_email_templates',
    },
  },
  { // MLD-5635
    path: '/v2/admin/mailgun/messages/:messageID(\\d+)',
    name: 'admin.mailgun_message.show',
    component: AdminShowMessage,
    meta: {
      permission: 'can_edit_email_templates',
    },
  },
]
